import { ATTRIBUTE_PANEL_WIDTH } from './attributes.styles';

export default (theme: Object) => ({
  root: {
    overflow: 'scroll',
  },
  noSelection: {
    minWidth: ATTRIBUTE_PANEL_WIDTH,
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    // Hide no-selection text on mobile
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});
